import React from "react";

export type modalProp = {
  width?: "sm" | "md" | "lg" | "xl";
  show?: boolean;
  onHide: () => void;
  title: string;
  children?: React.ReactNode;
  data?: Record<string, string | number | boolean | object | []>;
  transition?: "bond" | "sketch" | "unfolding" | "revealing" | "meep-meep";
  KeysToHide?: string[];
  handleViewObjects?: handleObj;
  modalClassName?:string;
  modalStyle?:React.CSSProperties;
};

export const elementStyle: ElementStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "1px solid #8080803b",
  padding: "10px",
};
